import {zDateTime} from '@brunata-angular/util';
import {z} from 'zod';
import {eventSchema} from '../event-alarms/event-alarm.model';

export const locationMeterSchema = z
    .object({
        meterId: z.number(),
        meterTypeNo: z.number(),
        locationId: z.number(),
        alloUnitType: z.string(),
        scale: z.number().nullable(),
        unitFactor: z.number().nullable(),
        unitReduction: z.number().nullable(),
        propertyNo: z.string().nullable(),
        branchNo: z.string().nullable(),
        locationNo: z.string().nullable(),
        address: z.string().nullable(),
        meterSuperTypeNo: z.number().nullable(),
        serialNo: z.string().nullable(),
        printedSerialNo: z.string().nullable(),
        mountingDate: zDateTime.nullable(),
        dismountedDate: zDateTime.nullable(),
        roomId: z.string().nullable(),
        meterBuildLength: z.number().nullable(),
        meterConnectionType: z.string().nullable(),
        shutoffValve: z.string().nullable(),
        supplyOrReturnFlow: z.string().nullable(),
        dinRail: z.boolean().nullable(),
        maxCurrent: z.number().nullable(),
        sensorPocket: z.boolean().nullable(),
        meterSize: z.string().nullable(),
        modelConfigurationId: z.string().nullable().optional(),
        meterConnectionTypeId: z.number().nullable().optional(),
        meterSequenceNo: z.number(),
        radioTechnology: z.string().nullable(),
        meterModel: z.string().nullable(),
        latitude: z.number().nullable(),
        longitude: z.number().nullable(),
        hasReadingsInPeriod: z.boolean().nullable(),
        eventTypesInPeriod: z.array(eventSchema.nullable()),
    })
    .transform(data => ({
        ...data,
        serialNo: `${data.serialNo}${data.printedSerialNo != null ? ` (${data.printedSerialNo})` : ''}`,
        meterId: data.meterId.toString(),
        meterTypeNo: data.meterTypeNo.toString(),
        locationId: data.locationId.toString(),
        proBraLoc: `${data.propertyNo ?? ''}-${data.branchNo ?? ''}-${data.locationNo ?? ''}`,
        meterConnectionTypeId: data.meterConnectionTypeId?.toString(),
    }));

export type LocationMeter = z.infer<typeof locationMeterSchema>;
